import { TrackLocationsView } from "@/features/track-location/components/TrackLocationsView"

export default function TrackLocationsPage() {
  return <TrackLocationsView />
}